<template>
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.17854 5.83544L9.75604 2.25794C10.0819 1.9321 10.0819 1.40544 9.75604 1.0796C9.43021 0.75377 8.90354 0.75377 8.57771 1.0796L5.00021 4.6571L1.42271 1.0796C1.09688 0.75377 0.570208 0.75377 0.244375 1.0796C-0.0814583 1.40544 -0.0814583 1.9321 0.244375 2.25794L3.82188 5.83544L0.244375 9.41294C-0.0814583 9.73877 -0.0814583 10.2654 0.244375 10.5913C0.406875 10.7538 0.620208 10.8354 0.833542 10.8354C1.04688 10.8354 1.26021 10.7538 1.42271 10.5913L5.00021 7.01377L8.57771 10.5913C8.74021 10.7538 8.95354 10.8354 9.16687 10.8354C9.38021 10.8354 9.59354 10.7538 9.75604 10.5913C10.0819 10.2654 10.0819 9.73877 9.75604 9.41294L6.17854 5.83544Z"
      fill="#E1E1E1"
    />
  </svg>
</template>
